import React from 'react';
import PropTypes from 'prop-types';

import CCSDropdown from '@ey/canvascoreservices/Dropdown';

const Dropdown = ({children, ...props}) => <CCSDropdown {...props}>{children && children}</CCSDropdown>;

export default Dropdown;
